export const REVIEW_ARCHIVE_PAGE_SIZE = 100
export const REVIEW_ARCHIVE_REVALIDATE_SECONDS = 1800
export const REVIEW_ARCHIVE_CDN_CACHE_CONTROL = `public, s-maxage=${REVIEW_ARCHIVE_REVALIDATE_SECONDS}, stale-while-revalidate=86400, stale-if-error=86400`
// Early years served as one paginated year page instead of month pages. Pinned
// rather than derived from review counts, so edits cannot switch a year between
// monthly and annual listings (MAR-125). Empty periods and out-of-range pages
// still 404. Changing this list moves live URLs, so ship redirects with it.
export const REVIEW_ARCHIVE_ROLLUP_YEARS: readonly string[] = [
  "2012",
  "2013",
  "2014",
  "2016",
]
// Failed inventories for the sitemap and llms.txt index expire before Retry-After,
// while repeated requests share the result within each loader instance.
export const REVIEW_ARCHIVE_DEGRADED_REVALIDATE_SECONDS = 60
export const REVIEW_ARCHIVE_RETRY_AFTER_SECONDS = 300
// A period still being filled joins the sitemap only once it *exceeds* this
// many reviews, so the 1st of a month never advertises a near-empty page.
export const REVIEW_SITEMAP_CURRENT_PERIOD_THRESHOLD = 50
export const REVIEW_SHOWCASE_LIMIT = 25
